import { useState } from 'react';
import { useDeleteMaxLessonsPerDayMutation, type MaxLessonsPerDay } from 'shared/api';

interface UseMaxLessonsPerDayDeleteProps {
  maxLessonsPerDay: MaxLessonsPerDay;
  refreshTable: () => void;
}

export const useMaxLessonsPerDayDelete = ({
  maxLessonsPerDay,
  refreshTable,
}: UseMaxLessonsPerDayDeleteProps) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [deleteMaxLessonsPerDay] = useDeleteMaxLessonsPerDayMutation();

  const showModal = () => {
    setModalVisible(true);
  };

  const hideModal = () => {
    setModalVisible(false);
  };

  const onSubmit = async () => {
    await deleteMaxLessonsPerDay(maxLessonsPerDay.id)
      .unwrap()
      .then(() => {
        hideModal();
        refreshTable();
      });
  };

  return {
    state: {
      modalVisible,
    },
    methods: {
      showModal,
      hideModal,
      onSubmit,
    },
  };
};
